module.exports = __webpack_public_path__ + "img/flutter-50.92199e12.svg";